import React from "react";
import { Container, Box, Grid, Paper, Typography, TextField, Button, CircularProgress } from '@material-ui/core';
import { withRouter } from 'react-router-dom';
import ApiService from './services/ApiService';
import { Service } from './services/DBService';
import { FormValidation } from "./services/FormValidation";

class Login extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      access_token: "",
      formFields: [ 'access_token' ],
      formErrors: {},
      isLoading: false
    }

    this.formAccessTokenValue = React.createRef();
    this._handleClick = this._handleClick.bind(this);
    this._handleChange = this._handleChange.bind(this);
    this._validateInput = this._validateInput.bind(this);
  }

  _validateInput(name, value) {
    let errors = {};
    var testResult = false;

    switch ( name ) {
      case 'access_token':
        testResult = FormValidation.requireText(name, value) && FormValidation.validateAccessToken(name, value);
        errors[name] = testResult ? "" : "Invalid access token.";
        break;
      default:
        
    }

    return errors;
  }

  _handleChange(e) {
    const { name, value } = e.target; 
    let error = this._validateInput(name, value);

    this.setState({ [name]: value, formErrors: { ...this.state.formErrors, [name]: error[name] } });
  }
  
  _handleClick(event) {
    let errors = FormValidation.validateForm(this.state.formFields, this.state, this._validateInput);
    
    if( errors.count === 0 ) {
      this.setState({ isLoading: true });

      ApiService.verifyAccessKey(this.formAccessTokenValue.current.value)
      .then(
        (data) => {
          // Check if data is valid
          if (!data) {
            console.error('verifyAccessKey returned no data');
            alert('Authentication Error: Unable to verify access token. Please check your connection and try again.');
            this.setState({ isLoading: false });
            return;
          }

          if(data.status !== 'badaccesskey') {
            localStorage.setItem('authenticated', 'true');  // ✅ Explicit string

            // Parse username from cookie
            let serverUser = '';
            const cookieMatch = document.cookie.match(/(?:^|;\s*)username\s*=\s*"?([^";]*)"?/);
            if (cookieMatch) {
              serverUser = cookieMatch[1];
            }
            
            const lastUser = localStorage.getItem('last_user');
            
            // If user changed, clear everything for fresh start
            if(serverUser && serverUser !== lastUser) {
              console.log('User changed from', lastUser, 'to', serverUser, '- clearing local data');
              localStorage.removeItem('last_sync');
              localStorage.setItem('last_user', serverUser);
              
              // Also clear the database to prevent data leakage between users
              Service.eraseDatabase()
                .then(() => {
                  console.log('Database cleared for new user');
                  this.props.history.push('/');
                })
                .catch(err => {
                  console.error('Error clearing database:', err);
                  // Still proceed to home, will be cleared on first sync
                  this.props.history.push('/');
                });
            } else {
              if (serverUser) localStorage.setItem('last_user', serverUser); // don't overwrite with ''
              this.props.history.push('/');
            }
          } else {
            console.log('Authentication failed: badaccesskey');
            alert('Authentication failed: Invalid access token.');
            this.setState({ isLoading: false });
            return false;
          }
        }
      ).catch(
        (err) => {
          console.error('verifyAccessKey error:', err);
          alert('Authentication Error: Unable to connect to server. Please check your connection and try again.');
          this.setState({ isLoading: false });
        }
      );
    } else {
      this.setState({ formErrors: { ...errors.msgs }});
      alert('Please enter a valid access token.');
    }
  }

  render() {
    return (
      <React.Fragment>
        <Container>
          <Paper>
            <Grid container spacing={3} align="center">
              <Grid item xs={12}>
                <Typography variant="h5" component="h2" gutterBottom>Login</Typography>
                <Typography variant="h6" component="h3" gutterBottom>Access Token</Typography>
              </Grid>
            </Grid>
            <Box my={3}>
              <Grid container spacing={3} align="center">
                <Grid item xs={12}>
                  <Typography variant="body2" color="textSecondary" component="p">
                    Access to LycoMMS data requires an application token.<br />(Four sets of characters in the format XXXX-XXXX-XXXX-XXXX)
                  </Typography>
                  <TextField
                    id="outlined-textarea"
                    label="Access Token"
                    placeholder="XXXX-XXXX-XXXX-XXXX"
                    variant="outlined"
                    name="access_token"
                    inputRef={ this.formAccessTokenValue }
                    onChange={ this._handleChange }
                    disabled={ this.state.isLoading }
                    {...(this.state.formErrors["access_token"] && { error: true, helperText: this.state.formErrors["access_token"] })}
                  />
                </Grid>
                <Grid item xs={12}>
                  {this.state.isLoading ? (
                    <CircularProgress />
                  ) : (
                    <Button variant="contained" color="primary" onClick={ this._handleClick } size="large" >Set Token</Button>
                  )}
                </Grid>
              </Grid>
            </Box>
          </Paper>
        </Container>
      </React.Fragment>
    );
  }
}

export default withRouter(Login);